// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__HqkCD","big":"Checkbox_big__nTGUV","small":"Checkbox_small__JeNqc","medium":"Checkbox_medium__qMQdI","sm":"Checkbox_sm__G9V9I"};